import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
const descriptionCss = "daxrvya";
const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});

// i18n-tasks-use t('publisher.event_types.location.outbound_call.popup.label')
// i18n-tasks-use t('publisher.event_types.location.outbound_call.popup.disabled_label')
// i18n-tasks-use t('publisher.event_types.location.inbound_call.popup.label')
// i18n-tasks-use t('publisher.event_types.location.inbound_call.popup.description')
// i18n-tasks-use t('publisher.event_types.location.outbound_call.popup.description')
export const RadioLabel = ({
  kind,
  isDisabled = false
}) => <>
    <div>
      {isDisabled ? I18n.t(`publisher.event_types.location.${kind}.popup.disabled_label`) : I18n.t(`publisher.event_types.location.${kind}.popup.label`)}
    </div>
    <Description>
      {I18n.t(`publisher.event_types.location.${kind}.popup.description`)}
    </Description>
  </>;

require("./radio_label.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./radio_label.js");